import { isEmpty } from "lodash";
import React, { useState, useRef, useCallback, useEffect } from "react";
import { useAppDispatch } from "src/store/actions/action";
import { setAsImage } from "src/store/reducers/asReduce";
import SVG from "src/utils/SVG";
import styled from "styled-components";
import VideoBox from "./VideoBox";
import IconButton from "./IconButton";
import imageCompression from "browser-image-compression";

const imageServerIp = process.env.REACT_APP_IMAGE_SERVER_IP;
interface IInputFileProps {
  className?: string;
  setPropsData?: any; // 추가 등록할 저장소
  setImageIndexData?: Array<string> | any; // 삭제할 파일 저장소
  registeredImage?: any; // 기존 등록된 이미지 저장소
  onChange?: (e: React.ChangeEvent<HTMLInputElement>) => void;
}

const InputFile = (props: IInputFileProps) => {
  // 파일 미리볼 url을 저장해줄 state
  const [fileImage, setFileImage]: any = useState([]);
  // 전송할 이미지를 저장하는 state
  const [fileImage2, setFileImage2]: any = useState([]);
  // 파일 삭제후 같은 파일 재 선택시 input value 삭제 -> onChange 변화감지 필요
  const [imageIndexData, setImageIndexData]: any = useState({
    deleteImages: props.setImageIndexData,
  });
  // 파일 사이즈 체크
  const [fileSize, setFileSize] = useState<number>();

  const [registeredImageData, setRegisteredImageData]: any = useState({
    registeDeleteImage: [],
  });

  const [registerLength, setRegisterLength] = useState<number>(0);

  // useEffect(() => {
  //   // 값을 복사해서 넣어야 실제 props의 데이터를 건들지 않아 readonly 에러가 안난다.
  //   if (!isEmpty(props.registeredImage)) {
  //   }
  // }, [props.registeredImage]);

  const fileInput = useRef<any>();

  const [state, setState] = useState({
    rerender: false,
  });
  const { rerender } = state;

  const [imageProgress, setImageProgress] = useState();

  useEffect(() => {
    if (props.registeredImage) {
      setRegisterLength(props.registeredImage.length);
      setRegisteredImageData({
        registeDeleteImage: [...props.registeredImage],
      });
      for (let i = 0; i < props.registeredImage.length; i++) {
        fileImage.push(imageServerIp + props.registeredImage[i].img_url);
      }
      setState({
        ...state,
        rerender: !rerender,
      });
    }
  }, [props.registeredImage]);

  // 파일 저장
  const saveFileImage = async (e: any) => {
    try {
      if (e.target.files.length > 0) {
        // TODO 완료보고 사진은 어떻게?
        if (e.target.files.length > 15) {
          alert("최대 파일 갯수는 15개 입니다.");
          return;
        }
        if (fileImage.length > 14) {
          alert("최대 파일 갯수는 15개 입니다.");
          return;
        }
        let totalFileSize = 0;
        for (let i = 0; i < e.target.files.length; i++) {
          totalFileSize += Number(e.target.files[i].size);
          const fileType = e.target.files[i].type;
          const oneFileSize = Number(e.target.files[i].size / 1024);
          // console.log(oneFileSize, "KB");
          // console.log(Math.round(oneFileSize / 1024), "MB");
          // 이미지 로직
          if (String(fileType).indexOf("image") > -1) {
            if (oneFileSize > 10000) {
              // 이미지 파일
              alert("하나의 사진 파일이 10MB보다 클 수 없습니다.");
              return;
            }
          } else if (String(fileType).indexOf("video") > -1) {
            if (oneFileSize > 30000) {
              // 동영상 파일
              alert("하나의 동영상 파일이 30MB보다 클 수 없습니다.");
              return;
            }
          }
          if (totalFileSize / 1024 > 150000) {
            alert("전체 파일 사이즈가 150MB를 넘길 수 없습니다.");
            return;
          }
        }

        const option = {
          maxSizeMB: 1,
          maxWidthOrHeight: 1920,
          initialQuality: 0.7,
          onprogress: setImageProgress,
        };

        for (let i = 0; i < e.target.files.length; i++) {
          const file = e.target.files[i];
          if (String(file.type).indexOf("image") > -1) {
            const compressedFile = await imageCompression(file, option);
            const newFile = new File([compressedFile], compressedFile.name);
            fileImage2.push(newFile);
            fileImage.push(URL.createObjectURL(compressedFile));
          } else {
            fileImage2.push(file);
            fileImage.push(URL.createObjectURL(file));
          }
        }
        console.log(imageProgress);
        setState({
          ...state,
          rerender: true,
        });
        props.setPropsData(fileImage2);
      }
    } catch (error) {
      alert("이미지 업로드 실패 다시 시도해 주세요");
      console.log("imageUpload Error", error);
    }
  };

  // 파일 삭제
  const deleteFileImage = (i: number, registeredCheck: string) => {
    if (registeredCheck) {
      if (imageIndexData) {
        const newImageIndexData = { ...imageIndexData };
        // const newRegisterImageIndexData = { ...registeredImageData };
        newImageIndexData.deleteImages.push(registeredImageData.registeDeleteImage[i]);
        // 등록된 사진을 끝이 아닌곳에서 삭제를 하면 index가 맞지 않은 오류를 해결하기위해
        // ...props.registeredImage 복사한 값을 삭제하여 index를 맞춰준다.
        registeredImageData.registeDeleteImage.splice(i, 1);
        // const tempArr = registeredImageData.registeDeleteImage.filter((_el: any, idx: number) => idx !== i);
        // setRegisteredImageData({
        //   registeDeleteImage: [...tempArr],
        // });
      }
    } else {
      // props.setImageIndexData!.push();
      // arrayList 지우기
      // 기존에 등록된 이미지의 index를 제외하기 위해 등록된 이미지 사이즈를 마이너스 해준다.
      // setFileImage2는 등록할 이미지만 저장한다.
      const fileArr2 = fileImage2.filter((_el: any, idx: number) => idx !== i - registerLength);
      setFileImage2([...fileArr2]);

      props.setPropsData([...fileArr2]);
    }
    const fileArr = fileImage.filter((_el: any, idx: number) => idx !== i);
    setFileImage([...fileArr]);
  };

  // dispatch를 통행 값을 추가하면 cannot add property 0, object is not extensible 해당 에러발생
  // 해당 변수에 더이상 object를 추가 할 수 없는것 같음 원인 파악해봐야 함
  // useEffect(() => {
  //   dispatch(setAsImage(fileImage2));
  // }, [state]);

  return (
    <InputFileSet>
      <label htmlFor="basic-file">파일업로드</label>
      <input id="basic-file" type="file" accept="image/*,video/*,.mov,.mp4" name="profile_img" multiple onChange={saveFileImage} ref={fileInput} />
      {fileImage.length > 0 && (
        <PreviewImg>
          {fileImage.map((v: any, i: number) => {
            let registeredImageCheck = "";
            if (String(v).indexOf("attachment") > -1) {
              registeredImageCheck = "R";
            }
            return (
              <li key={i}>
                <div>
                  {registeredImageCheck === "" || String(fileImage[i]).indexOf(".jp") > -1 || String(fileImage[i]).indexOf(".png") > -1 ? (
                    <img alt="sample" src={v} />
                  ) : (
                    <VideoBox
                      //src={v}
                      // TODO 수정 해야 함
                      vimeoId={v}
                    />
                  )}
                </div>
                <IconButton btnName="미리보기 삭제하기" onClick={() => deleteFileImage(i, registeredImageCheck)}>
                  <SVG name="thumbDel" width={24} height={24} viewBox="0 0 24 24" />
                </IconButton>
              </li>
            );
          })}
        </PreviewImg>
      )}
    </InputFileSet>
  );
};

const PreviewImg = styled.ul`
  overflow: hidden;
  overflow-x: scroll;
  ${({ theme }) => theme.flexBox.flexMixin("row", "flex-start", "flex-start")}
  flex: 1;
  &::-webkit-scrollbar {
    display: none; /* Chrome, Safari, Opera*/
  }
  > li {
    position: relative;
    padding: 3px 3px 0 0;
    > div {
      overflow: hidden;
      position: relative;
      width: 72px;
      height: 72px;
      border: 1px solid #ddd;
      border-radius: 4px;
      > img {
        position: absolute;
        left: 50%;
        top: 50%;
        transform: translate(-50%, -50%);
        display: block;
        object-fit: cover;
        max-width: 100%;
        height: auto;
        box-sizing: border-box;
      }
    }
    > button {
      position: absolute;
      top: 0;
      right: 0;
      width: 24px;
      height: 24px;
    }
  }
`;

const InputFileSet = styled.div`
  ${({ theme }) => theme.flexBox.flexMixin("row", "flex-start", "flex-start")}
  > label {
    position: relative;
    flex-basis: 72px;
    display: inline-block;
    width: 72px;
    height: 72px;
    margin: 3px 3px 0 0;
    border: 1px dashed ${({ theme }) => theme.color.lineSecondary};
    border-radius: 4px;
    font-size: 0;
    &::before {
      position: absolute;
      top: 50%;
      left: 50%;
      content: "";
      display: block;
      width: 1px;
      height: 11px;
      margin-top: -5px;
      background-color: ${({ theme }) => theme.color.lineSecondary};
    }
    &::after {
      position: absolute;
      top: 50%;
      left: 50%;
      content: "";
      display: block;
      width: 11px;
      height: 1px;
      margin-left: -5px;
      background-color: ${({ theme }) => theme.color.lineSecondary};
    }
  }
  > input[type="file"] {
    ${/* 파일 필드 숨기기 */ ""}
    position: absolute;
    width: 1px;
    height: 1px;
    padding: 0;
    margin: -1px;
    overflow: hidden;
    clip: rect(0, 0, 0, 0);
    border: 0;
  }
`;

export default InputFile;
function e(i: number, e: any): React.MouseEventHandler<HTMLButtonElement> | undefined {
  throw new Error("Function not implemented.");
}
